'use client'

import { useState } from 'react'

import { QrReader, type OnResultFunction } from 'react-qr-reader'

import { useBorderColor } from '../../../hooks/useBorderColor'

import { env } from '@/env'
import { cn } from '@/shared/lib/utils'
import { inputClassName } from '@/shared/ui/input-styles'

interface QuestionQRCodeProps {
  onScan: (code: string) => void
  disabled: boolean
}

const isDev = env.NEXT_PUBLIC_PGEE_APP_ENV === 'development'
const KNOWN_ERRORS = ['DOMException: Requested device not found']

export function QuestionQRCode({ onScan, disabled }: QuestionQRCodeProps) {
  const [qrReaderError, setQrReaderError] = useState<string | boolean>(false)
  const [manualCode, setManualCode] = useState('')
  const { borderColor } = useBorderColor()

  const handleResult: OnResultFunction = (result, error) => {
    if (disabled) return
    if (result && result.getText()) {
      const code = result.getText()
      onScan(code)
    }
    if (error && error.toString() !== 'e') {
      setQrReaderError(error.message ?? String(error))
    }
  }

  const handleManualSubmit = () => {
    if (manualCode.trim()) {
      onScan(manualCode.trim())
    }
  }

  return (
    <div className="flex flex-col items-center gap-4 w-full max-w-md mx-auto">
      <div
        className={`
          aspect-square w-full max-w-[300px] border-2 rounded-xl overflow-hidden
          ${borderColor}
        `}
      >
        <QrReader
          onResult={handleResult}
          constraints={{ facingMode: 'environment' }}
          className="w-full h-full bg-gray-200"
        />
      </div>

      {qrReaderError && (
        <div className="text-red-500 text-sm text-center">
          Erro no leitor QR: {qrReaderError}
        </div>
      )}

      <div className="w-full">
        <span className="block font-bold text-center text-gray-700 mb-2">
          Ou digite o código
        </span>
        <div className="flex gap-2">
          <input
            type="text"
            value={manualCode}
            onChange={e => setManualCode(e.target.value)}
            placeholder="Insira aqui o código"
            disabled={disabled}
            className={cn(
              inputClassName,
              'flex-1',
              disabled && 'opacity-50 cursor-not-allowed'
            )}
            onKeyPress={e => {
              if (e.key === 'Enter') {
                handleManualSubmit()
              }
            }}
          />
          <button
            type="button"
            onClick={handleManualSubmit}
            disabled={disabled || !manualCode.trim()}
            className="px-4 py-2 bg-primary text-white rounded-lg disabled:opacity-50"
          >
            Enviar
          </button>
        </div>
      </div>
    </div>
  )
}
